import { PrimitiveAtom, useAtom } from 'jotai'

import { MenuItem } from '@/components/ui/menu'
import { getSelectedTopic, helpCenterSelectedTopicAtom, helpCenterTopicsAtom, showHelpCenterDrawerAtom } from '@/store/helpCenter'
import { ITopic } from '@/types/helpCenter'

const HelpCenterList = () => {
    const [helpCenterTopics] = useAtom<ITopic[]>(helpCenterTopicsAtom)
    const [, setHelpCenterSelectedTopic] = useAtom<PrimitiveAtom<ITopic | null>>(helpCenterSelectedTopicAtom)
    const [, showHelpCenterDrawer] = useAtom<PrimitiveAtom<boolean>>(showHelpCenterDrawerAtom)

    const handleClick = (topicId: number) => {
        setHelpCenterSelectedTopic(getSelectedTopic(helpCenterTopics, topicId))
        showHelpCenterDrawer(true)
    }
    return (
        <>
            {helpCenterTopics
                .filter((item) => item.type !== 'RAISE_QUOTA')
                .map((item) => (
                    <MenuItem value={item.id.toString()} key={item.name} onClick={() => handleClick(item.id)} closeOnSelect={true}>
                        {item.name}
                    </MenuItem>
                ))}
        </>
    )
}

export default HelpCenterList
